<template>
	<v-layout row justify-center>
		<v-menu left>
			<v-btn icon slot="activator" class="mt-3">
				<v-icon>av_timer</v-icon>
			</v-btn>
			<v-list>
				<v-list-tile v-for="period in periods" :key="period.value">
					<v-list-tile-title @click="setPeriod(period.value)">{{
						period.text
					}}</v-list-tile-title>
				</v-list-tile>
			</v-list>
		</v-menu>
	</v-layout>
</template>

<script>
import * as utils from '@/utils/utils';
import moment from 'moment';
export default {
	name: 'selectPeriod',
	data() {
		return {
			periods: [
				{
					value: '1 hours',
					text: '+ 1 uur'
				},
				{
					value: '4 hours',
					text: '+ 1 dagdeel (4 uur)'
				},
				{
					value: '1 days',
					text: '+ 1 dag'
				},
				{
					value: '7 days',
					text: '+ 1 week'
				},
				{
					value: '1 months',
					text: '+ 1 maand'
				},
				{
					value: '1 end',
					text: 'Eind v/d dag'
				}
			],
			showModal: false,
			selectedPeriod: '',
			utils: utils,
			endTime: '',
			endDate: ''
		};
	},
	props: ['time', 'day'],
	computed: {},
	mounted() {},
	methods: {
		setPeriod(period) {
			var data = {};
			var addData = period.split(' ');
			var formatTime = 'HH:mm';
			var format = 'YYYY-MM-DD HH:mm';
			var formatDays = 'YYYY-MM-DD';
			var startTime = moment(this.time, formatTime);
			var startDate = moment(this.day, format);

			switch (addData[1]) {
				case 'hours':
					const startHours = parseInt(startTime.format('HH'));
					data['endTime'] = startTime
						.add(parseInt(addData[0]), addData[1])
						.format(formatTime);

					const endHours = parseInt(
						moment(data['endTime'], formatTime).format('HH')
					);

					if (endHours < startHours) {
						data['endDate'] =
							startDate.add(1, 'days').format(formatDays) +
							' ' +
							startTime.format(formatTime);
					} else {
						data['endDate'] =
							startDate.format(formatDays) + ' ' + startTime.format(formatTime);
					}

					break;

				case 'days':
				case 'months':
					data['endTime'] = startTime.format(formatTime);
					data['endDate'] =
						startDate.add(parseInt(addData[0]), addData[1]).format(formatDays) +
						' ' +
						startTime.format(formatTime);
					break;
				case 'end':
					data['endTime'] = '23:59';
					data['endDate'] =
						startDate.format(formatDays) + ' ' + data['endTime'];
					break;
			}

			this.$emit('setPeriod', data);
		}
	}
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Reservations/SelectPeriod.vue